import { useState } from "react";
import { Typography, Button, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function DetailsCard({ job }) {
  const [summaryExpanded, setSummaryExpanded] = useState(false);
  const [dutiesExpanded, setDutiesExpanded] = useState(false);

  const LINE_LIMIT = 14;

  return (
    <>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {job.title?.toUpperCase()}
      </Typography>

      {job.company && (
        <Typography gutterBottom>
          <strong>Company:</strong> {job.company}
        </Typography>
      )}

      {job.location && (
        <Typography gutterBottom>
          <strong>Location:</strong>{" "}
          {job.location !== ""
            ? job.location
            : [job.city, job.state, job.country].filter(Boolean).join(", ")}
        </Typography>
      )}

      {job.summary && (() => {
        const lines = job.summary.split('\n');
        const hasMoreLines = lines.length > LINE_LIMIT;
        const displayText = summaryExpanded || !hasMoreLines
          ? job.summary
          : lines.slice(0, LINE_LIMIT).join('\n') + '...';
        
        return (
          <Box sx={{ mb: 2 }}>
            <Typography gutterBottom style={{ whiteSpace: 'pre-wrap' }}>
              <strong>Summary:</strong> {displayText}
            </Typography>
            {hasMoreLines && (
              <Button
                size="small"
                onClick={() => setSummaryExpanded(!summaryExpanded)}
                startIcon={summaryExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{ textTransform: "none", p: 0, minWidth: "auto" }}
              >
                {summaryExpanded ? "Show less" : "Show more"}
              </Button>
            )}
          </Box>
        );
      })()}

      {job.dutiesResponsibilities && (
        <Box sx={{ mb: 2 }}>
          <Typography gutterBottom>
            <strong>Duties & Responsibilities:</strong>
          </Typography>
          <Box
            sx={{
              ...(!dutiesExpanded && {
                display: '-webkit-box',
                WebkitLineClamp: LINE_LIMIT,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }),
            }}
          >
            <Typography
              component="div"
              dangerouslySetInnerHTML={{
                __html: job.dutiesResponsibilities || "",
              }}
            />
          </Box>
          <Button
            size="small"
            onClick={() => setDutiesExpanded(!dutiesExpanded)}
            startIcon={dutiesExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            sx={{ textTransform: "none", p: 0, minWidth: "auto", mt: 1 }}
          >
            {dutiesExpanded ? "Show less" : "Show more"}
          </Button>
        </Box>
      )}

      {job.requiredEducation && (
        <Typography gutterBottom>
          <strong>Education:</strong> {job.requiredEducation}
        </Typography>
      )}

      {job.workplacePolicy && (
        <Typography gutterBottom>
          <strong>Workplace Policy:</strong> {job.workplacePolicy}
        </Typography>
      )}
    </>
  );
}
